export default __webpack_public_path__ + "static/media/TL02.1.d341d94b.mp3";